/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CatalogItem,
    CatalogItemFromJSON,
    CatalogItemFromJSONTyped,
    CatalogItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface DealCreate
 */
export interface DealCreate {
    /**
     * 
     * @type {number}
     * @memberof DealCreate
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof DealCreate
     */
    readonly user?: number;
    /**
     * 
     * @type {CatalogItem}
     * @memberof DealCreate
     */
    estate?: CatalogItem;
    /**
     * 
     * @type {number}
     * @memberof DealCreate
     */
    readonly agreedContract?: number;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly status?: DealCreateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly stage?: DealCreateStageEnum;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly typeOfProperty?: DealCreateTypeOfPropertyEnum;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly basePaymentType?: DealCreateBasePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly additionalPaymentType?: DealCreateAdditionalPaymentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof DealCreate
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DealCreate
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DealCreate
     */
    readonly amoStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DealCreate
     */
    readonly dutyPaid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DealCreate
     */
    readonly noteSend?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DealCreate
     */
    appeal: number;
}

export function DealCreateFromJSON(json: any): DealCreate {
    return DealCreateFromJSONTyped(json, false);
}

export function DealCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'estate': !exists(json, 'estate') ? undefined : CatalogItemFromJSON(json['estate']),
        'agreedContract': !exists(json, 'agreedContract') ? undefined : json['agreedContract'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'stage': !exists(json, 'stage') ? undefined : json['stage'],
        'typeOfProperty': !exists(json, 'typeOfProperty') ? undefined : json['typeOfProperty'],
        'basePaymentType': !exists(json, 'basePaymentType') ? undefined : json['basePaymentType'],
        'additionalPaymentType': !exists(json, 'additionalPaymentType') ? undefined : json['additionalPaymentType'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'amoStatus': !exists(json, 'amoStatus') ? undefined : json['amoStatus'],
        'dutyPaid': !exists(json, 'dutyPaid') ? undefined : json['dutyPaid'],
        'noteSend': !exists(json, 'noteSend') ? undefined : json['noteSend'],
        'appeal': json['appeal'],
    };
}

export function DealCreateToJSON(value?: DealCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estate': CatalogItemToJSON(value.estate),
        'appeal': value.appeal,
    };
}

/**
* @export
* @enum {string}
*/
export enum DealCreateStatusEnum {
    New = 'new',
    Complete = 'complete',
    Canceled = 'canceled'
}
/**
* @export
* @enum {string}
*/
export enum DealCreateStageEnum {
    Booking = 'booking',
    TypeOfOwnership = 'type_of_ownership',
    LoadOwners = 'load_owners',
    PayOptions = 'pay_options',
    LoadPayData = 'load_pay_data',
    Agreement = 'agreement',
    SigningOptions = 'signing_options',
    CheckContractSigned = 'check_contract_signed',
    PayStateDuty = 'pay_state_duty',
    Transaction = 'transaction',
    PayUnderContract = 'pay_under_contract',
    Final = 'final',
    SendDealData = 'send_deal_data'
}
/**
* @export
* @enum {string}
*/
export enum DealCreateTypeOfPropertyEnum {
    Single = 'single',
    Spouses = 'spouses',
    SpousesSingle = 'spouses_single',
    SharedOwnership = 'shared_ownership',
    SharedOwnershipWithChildren = 'shared_ownership_with_children'
}
/**
* @export
* @enum {string}
*/
export enum DealCreateBasePaymentTypeEnum {
    Payment100 = 'payment_100',
    TradeIn = 'trade_in',
    Mortgage = 'mortgage',
    InstallmentPayment = 'installment_payment'
}
/**
* @export
* @enum {string}
*/
export enum DealCreateAdditionalPaymentTypeEnum {
    Nope = 'nope',
    MaternalCapital = 'maternal_capital',
    HousingCertificate = 'housing_certificate',
    MilitaryCertificate = 'military_certificate'
}


